<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <template v-if="keyWords == 'w'">
        <img
          style="width: 100vw; height: auto; display: block"
          src="../assets/images/advertise/P2-1.jpg"
          alt=""
        />
        <video
          style="width: 100vw"
          controls
          v-for="(item, index) in list1"
          :key="index"
          :src="item.src"
          :poster="item.cover"
        ></video>
        <van-image
          v-for="item in imageList"
          :key="item.id"
          width="100vw"
          height="auto"
          show-loading
          :src="item.src"
        />
      </template>
      <template v-else-if="keyWords == 'x'">
        <div class="xj">
          <img
            style="display: block"
            src="../assets/images/advertise/xj1.png"
            alt=""
          />
          <video
            style="width: 100vw"
            controls
            v-for="(item, index) in list3"
            :key="index"
            :src="item.src"
            :poster="item.cover"
          ></video>
          <img src="../assets/images/advertise/xj2.png" alt="" />
          <img src="../assets/images/advertise/xj3.png" alt="" />
          <img src="../assets/images/advertise/xj4.png" alt="" />
        </div>
      </template>
      <template v-else>
        <div class="article2">
          <h3>东芝硬盘 助力智慧安防新赛道</h3>
          <p class="paragraph">
            东芝电子元件（上海）有限公司是东芝电子元件及存储装置株式会社的全资子公司。东芝提供广泛的创新型硬盘驱动器（HDD）产品，以满足多元化存储市场的各种需求，其中包括针对云数据中心的高容量高能效存储，适合企业IT容量及性能的硬盘，面向PC/台式机的客户端硬盘，以及用于监控、NAS系统、机顶盒视频、游戏和外部存储的专用硬盘。东芝致力于继续推动硬盘技术和创新，以满足和超越广泛存储市场细分领域的客户需求。
          </p>

          <img src="../assets/images/advertise/t1.jpg" alt="" />
          <h5>适用环境</h5>
          <p class="paragraph">
            在智慧安防新赛道中，东芝提供了三种类型的监控存储产品，满足监控DVR、公共安全NVR、中央化监控视频分析等不同系统和工作负载的要求。
            其中热销的DT02-VH系列，采用不间断传输模式，数据传输速度最高176.4MiB/s，保障录像机稳定录入的同时，能确保回放的流畅性，有效地进行数据分析
          </p>
          <img src="../assets/images/advertise/t2.jpg" alt="" />

          <h5>工作时长及稳定性</h5>
          <p class="paragraph">
            应用监控环境要求硬盘必须可以长时间连续工作，稳定平滑录入高清流媒体，并支持随时调取和回放，能满足这个要求的就是监控硬盘。
          </p>
          <p class="paragraph">
            普通硬盘的“上班制”是以5*8小时为基础设计，如果用它来全天录像，长期“007”式工作，反而会“过度疲劳”造成不必要的损耗，并不适用监控环境。而监控硬盘是按7*24小时、全年无休的企业级环境要求进行设计开发的，全天候无间断录像，专供监控行业使用。
          </p>
          <img
            style="width: 25%"
            src="../assets/images/advertise/t3.png"
            alt=""
          />
          <p class="paragraph">
            东芝的DT02-VH系列，为高要求的7*24小时全天候运行、多流监控环境提供优化的性能。每年的写入量高达180TB，100万小时的平均无故障时间，保证视频录制的连贯性，防止丢帧。
          </p>

          <h5>运行功耗及散热差别</h5>
          <p class="paragraph">
            硬盘运行产生的功耗很大一部分会转为热能，在数字硬盘录像机狭小的空间里，随着硬盘的运行，功耗会直接影响系统的散热。监控硬盘在运行时，功耗远小于普通硬盘功耗，不仅对电源的压力减小了，而且会改善系统散热，更适应录像设备的运行环境。
          </p>
          <img src="../assets/images/advertise/t4.png" alt="" />
          <p class="paragraph">
            东芝监控硬盘DT02-VH系列，在硬盘正常读写状态下，可在0-60℃温度范围内运行；在待机状态时保持低功耗，4TB、6TB硬盘待机功耗分别为2.33W、2.81W。同时具备自适应功率模式控制功能，与正常运行相比，能节约高达15%的电源，同时确保驱动器在转瞬之间恢复运作。既改善功耗散热，又提高能效利用。
          </p>
          <span class="tip">*功耗：指硬盘在正常读写状态下的功耗。</span>

          <h5>敏捷及抗震性</h5>
          <p class="paragraph">
            监控硬盘着重在不断时的匀速记录，针对这一特点，其磁头做了结构优化设计，侧重延长磁头的使用寿命。东芝则在此基础上精益求精，DT02-VH系列的256MiB缓冲区，可以支持64
            个摄像头进行高清记录，方便灵活应对未来系统的扩展。
          </p>
          <img src="../assets/images/advertise/t5.jpg" alt="" />

          <p class="paragraph">
            众所周知，监控设备安装环境比较复杂，再加上监控设备要求全天候不间断工作，所以抗振性能尤为重要。东芝监控型硬盘内置旋转振动传感器（RVS），能补偿来自驱动器本身或者外部的任何旋转振动，不间断读取和写入，在保持高性能的同时防止数据丢失和掉帧现象。
          </p>

          <h5>——</h5>
          <p class="paragraph">
            其实这么对比下来，应用环境不同，产品性能也大有不同。东芝监控硬盘充分考虑了监控领域对存储系统的要求，进行设计、开发、优化，从而提高硬盘对监控的适用性。归根结底，东芝硬盘始终希望每款产品都能协助企业解决不同需求，提供专业、安全、可靠的存储服务！
          </p>
          <h5>视频介绍</h5>
        </div>
        <video
          style="width: 100vw"
          controls
          v-for="(item, index) in list2"
          :key="index"
          :src="item.src"
          :poster="item.cover"
        ></video>
      </template>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      keyWords: "",
      show: false,
      showVideo: true,
      msgboxTop: 0,
      src1: require("../assets/images/advertise/P2-2.jpg"),
      imageList: [
        { id: 4, src: require("../assets/images/advertise/P2-2.jpg") },
        { id: 3, src: require("../assets/images/advertise/P2-3.jpg") }
      ],
      list1: [
        {
          id: 4,
          src: require("../assets/video/p1.mp4"),
          cover: require("../assets/images/advertise/a4.png")
        },
        {
          id: 5,
          src: require("../assets/video/p2.mp4"),
          cover: require("../assets/images/advertise/a5.png")
        },
        {
          id: 6,
          src: require("../assets/video/p3.mp4"),
          cover: require("../assets/images/advertise/a6.png")
        }
      ],
      list2: [
        {
          id: 7,
          src: require("../assets/video/DONGZHI1.mp4"),
          cover: require("../assets/images/advertise/a2.png")
        },
        {
          id: 8,
          src: require("../assets/video/DONGZHI2.mp4"),
          cover: require("../assets/images/advertise/a3.png")
        }
      ],
      list3: [
        {
          id: 7,
          src: require("../assets/video/40year.mp4"),
          cover: require("../assets/images/advertise/a1.png")
        },
        {
          id: 8,
          src: require("../assets/video/XIJIE2.mp4"),
          cover: require("../assets/images/advertise/a7.png")
        }
      ]
    };
  },
  created() {
    if (this.$route.query) {
      this.keyWords = this.$route.query.src;
    }
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.src != from.query.src) {
        this.keyWords = to.query.src;
      }
    },
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style scoped>
video {
  display: block;
}
.main /deep/ .van-image__img {
  border-radius: 0px;
  display: block;
}
.main /deep/.van-image {
  display: block;
}
.article,
.article2 {
  text-align: center;
  padding: 15px 15px;
}

.article h3,
.article2 h3 {
  padding: 15px 0;
  text-align: center;
}
.paragraph {
  text-align: justify;
  line-height: 1.5;
  text-indent: 2em;
  padding: 5px 0;
}
.small {
  text-align: justify;
  word-break: break-all;
  font-size: 12px;
}
.article2 h5 {
  text-align: center;
}
.article2 img {
  padding: 15px 0;
  margin: 0 auto;
  max-width: 50%;
}
.tip {
  display: block;
  font-size: 12px;
  text-align: left;
  padding-bottom: 12px;
  color: darkgray;
}
.xj img {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
